export default "__VITE_ASSET__nGt8aV$E__"